import React from "react";

const ETAPAS = [
  { chave: "enviadas", rotulo: "Mensagens enviadas", cor: "bg-amber-500" },
  { chave: "abriram", rotulo: "Abriram o cardápio", cor: "bg-sky-500" },
  { chave: "responderam", rotulo: "Responderam a CLEO", cor: "bg-purple-500" },
  { chave: "pediram", rotulo: "Fizeram pedido", cor: "bg-emerald-500" },
];

const fmtData = (iso) => iso.split("-").reverse().join("/");

export default function Funil({ funil, medidoDesde, inicioPeriodo }) {
  const base = funil?.enviadas || 0;
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5" data-e2e="funil-recuperador">
      <h3 className="font-semibold">Funil</h3>
      <p className="text-xs text-muted-foreground mb-4">Do que a CLEO mandou até o pedido. Porcentagens sobre as mensagens enviadas.</p>
      {base === 0 ? (
        <p className="text-sm text-muted-foreground py-4 text-center">Nenhuma mensagem medida no período.</p>
      ) : (
        <div className="space-y-3">
          {ETAPAS.map(({ chave, rotulo, cor }) => {
            const n = funil[chave] || 0;
            const pct = Math.round((n * 1000) / base) / 10;
            return (
              <div key={chave}>
                <div className="flex justify-between text-sm mb-1">
                  <span>{rotulo}</span>
                  <span className="tabular-nums font-semibold">{n} <span className="text-muted-foreground font-normal">· {String(pct).replace(".", ",")}%</span></span>
                </div>
                <div className="h-2.5 rounded-full bg-muted overflow-hidden">
                  <div className={`h-full rounded-full ${cor}`} style={{ width: `${Math.max(pct, n ? 2 : 0)}%` }} />
                </div>
              </div>
            );
          })}
        </div>
      )}
      {medidoDesde && inicioPeriodo < medidoDesde && (
        <p className="text-[11px] text-muted-foreground mt-3">
          Aberturas e respostas são medidas desde {fmtData(medidoDesde)}. Mensagens antigas entram nos números de cima, mas não no funil.
        </p>
      )}
    </section>
  );
}
